export default __webpack_public_path__ + "static/media/logo.9ccd7f84.png";